// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "templates/assets/" + "fe057ad9c580bba1cbdc" + "." + chunkId + ".js";
};